import { ChatBubbleService } from './chat-bubble.service';
import { EmulatorMessage } from '../../../../../shared/models/emulator';
import {
  Component,
  EmbeddedViewRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { SMS, USSD } from '../../../../../shared/utils/config';

@Component({
  selector: 'app-chat-bubble',
  templateUrl: './chat-bubble.component.html',
  styleUrls: ['./chat-bubble.component.scss'],
})

export class ChatBubbleComponent implements OnInit {
  @Input() emulatorMessage: EmulatorMessage;
  @Output() sendMessage: EventEmitter<any> = new EventEmitter();
  @Output() sendLocation: EventEmitter<any> = new EventEmitter();
  @ViewChild('urlPreviewContainer', { static: true }) urlPreviewContainer!: TemplateRef<any>;

  urlPreviewData: {mainUrl: string, rootUrl: string, remainder: string} = null;
  public shouldShowCharCount = false;
  public charCount: number;
  public currentChannel: number;

  constructor(public chatBubbleService: ChatBubbleService, private viewContainerRef: ViewContainerRef) {}
  ngOnInit() {
    this.currentChannel = this.emulatorMessage.channelId;
    this.checkURL();
    this.shouldShowCharCount = this.showCharacterCount();
    if (this.shouldShowCharCount) {
      this.charCount = this.getStringLength(this.getFullString());
    }
  }

  private getFullString(): string {
    let str = '';
    if (this.urlPreviewData['mainUrl'] !== null) {
      str += this.urlPreviewData['mainUrl'];
    }
    if (this.urlPreviewData['rootUrl'] !== null) {
      str += this.urlPreviewData['rootUrl'];
    }
    if (this.urlPreviewData['remainder']) {
      str += this.urlPreviewData['remainder'];
    }
    return str;
  }

  checkURL() {

    if (this.emulatorMessage.mediaMetaData["bubbleType"] === "contact") {
      this.urlPreviewData = null;
      return
    }

    if (this.emulatorMessage.channelPayload) {
      this.urlPreviewData = {mainUrl: '', rootUrl: '', remainder: ''};
      if (this.emulatorMessage.channelPayload['event']) {
          this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.channelPayload['event']['moText'][0]['content']);
          return this.urlPreviewData;
      }
      if (this.emulatorMessage.channelPayload['messages']) {
        this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.channelPayload['messages'][0]['content']);
        return this.urlPreviewData;
      }
      }

    this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.message);
    return this.urlPreviewData;
  }
  checkdefaultURL(): String {
    if (this.emulatorMessage.channelPayload) {
      if (this.emulatorMessage.channelPayload['event']) {
        return this.chatBubbleService.urlCheck(this.emulatorMessage.channelPayload['event']['moText'][0]['content']);
      }
      if (this.emulatorMessage.channelPayload['messages']) {
        return this.chatBubbleService.urlCheck(this.emulatorMessage.channelPayload['messages'][0]['content']);
      }
    }

     return this.chatBubbleService.urlCheck(this.emulatorMessage.message);
  }
  getStringLength(str) {
    if (!str) { return; }
    return str.replace(/(<([^>]+)>)/gi, '').trim().length;
  }

  get content() {
    return this.emulatorMessage.mediaMetaData;
  }

  get bubbleType() {
    return this.emulatorMessage.mediaMetaData['bubbleType'];
  }

  get direction() {
    return this.chatBubbleService.isUserMessage(this.emulatorMessage);
  }

  getRequestLocationContent() {
    return this.emulatorMessage.channelPayload;
  }

  showCharacterCount(): boolean {
    return (
      !this.direction &&
      (this.emulatorMessage.channelId === USSD || this.emulatorMessage.channelId === SMS)
    );
  }

  sendMessageEmitter(event) {
    this.sendMessage.emit(event);
  }

  sendLocationEmitter(event) {
    this.sendLocation.emit(event);
  }
}
